/* eslint-disable import/prefer-default-export */
export const getTabs = state => state.tabs
export const getListsParams = state => state.listsParams
export const getNewProductsColumnsList = state => state.newProductsColumnsList
export const getUsedProductsColumnsList = state => state.usedProductsColumnsList

export const getIsEditionModeEnabled = state => state.isEditionModeEnabled
export const getIsLoadingGlobalResponse = state => state.isLoadingGlobalResponse
